// @flow

import api from "api";
import * as resources from "resources";

export const fetchData = (url: string) => {
  return api.get(url);
};
export const fetchStructure = (url: string) => {
  return api.get(url);
};
export const postData = (url: string, data: any) => {
  return api.post(url, data);
};
export const deleteData = (url: string) => {
  return api.delete(url);
};

// components
export const fetchIua = (id: number) => {
  return api.get(resources.DataGET.INSTITUTION_IUA_BY_ID(id));
};

export const fetchIuaSuggestDto = (id: number) => {
  return api.get(resources.DataGET.INSTITUTION_SUGGEST_BY_IUA_ID(id));
};

export const fetchPerson = (id: number) => {
  return api.get(resources.DataGET.PERSON_MAIN_INFO(id));
};

export const fetchPersonSuggestDto = (id: number) => {
  return api.get(resources.DataGET.PERSON_NAME_BY_ID(id));
};

export const isEmailUnique = (email: string) => {
  return api.get(resources.DataGET.USERNAME_AVAILABLE(email));
};
